module.exports = __webpack_public_path__ + "media/images/svg/package-icon-8c0188c85c1f886aafaec49b40acee80.png";